/** "$8,000.00" a partir del string decimal del contrato ("8000.00"). */
export function mxn(value: string | number | null | undefined): string {
  const n = typeof value === 'string' ? Number(value) : (value ?? 0);
  return n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
}

/** "5 de octubre de 2026" desde "2026-10-05" (fecha de negocio, sin zona). */
export function fechaLarga(iso: string | null | undefined): string {
  if (!iso) return '—';
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return iso;
  return new Intl.DateTimeFormat('es-MX', { dateStyle: 'long', timeZone: 'UTC' }).format(
    new Date(Date.UTC(y, m - 1, d, 12)),
  );
}

/** "6 oct 2026, 13:05" (hora de la Ciudad de México) desde un ISO con zona. */
export function fechaHora(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Intl.DateTimeFormat('es-MX', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: 'America/Mexico_City',
  }).format(new Date(iso));
}

const ENTERO = new Intl.NumberFormat('es-MX');

/** Número con separador de miles (es-MX). */
export function numero(v: number): string {
  return ENTERO.format(v);
}

/** `2026-03` → «mar 26». */
export function mesCorto(mes: string): string {
  const [a, m] = mes.split('-').map(Number);
  if (!a || !m) return mes;
  return new Intl.DateTimeFormat('es-MX', { month: 'short', year: '2-digit' }).format(
    new Date(a, m - 1, 1),
  );
}
